import { buildMaybePartnerRoute } from '../../helpers/builders.js';

const schedulingFlowRoute = (draftWaypointID, locationData, isRescheduling, shiftID, shiftCancelReason, location) => {
    var _a;
    return buildMaybePartnerRoute({
        ...locationData,
        path: `/schedule/${draftWaypointID}`,
        query: {
            isRescheduling: isRescheduling ? 'true' : undefined,
            shiftID: shiftID !== null && shiftID !== void 0 ? shiftID : undefined,
            shiftCancelReason: shiftCancelReason !== null && shiftCancelReason !== void 0 ? shiftCancelReason : undefined,
            location: (_a = JSON.stringify(location)) !== null && _a !== void 0 ? _a : undefined,
        },
    });
};

export { schedulingFlowRoute };
